// extracted by mini-css-extract-plugin
export default {"privacy":"Drill_privacy__jbVKK","listLink":"Drill_listLink__6NRhb"};